<template>
  <transition
    appear
    name="custom-classes-transition"
    enter-active-class="animated fadeIn faster"
    leave-active-class="animated fadeOut faster"
  >
    <popup v-if="show">
      <div class="ui-message-tips">
        <div class="ui-content" v-if="type === 'intro'">
          <img
            class="close"
            @click="onClose"
            :src="`${$cdn}images/close@2x.png`"
            alt
          />
          <h1>景区简介</h1>
          <div class="content">
            <p>
              三亚国际免税城旅游区位于海南省三亚市国家海岸海棠湾内，是集免税购物、有税购物、餐饮娱乐、文化展示、旅游休闲于一身的国际化综合度假目的地，是中、高端旅游者必游的海南景点。
            </p>
            <img v-viewer :src="`${$cdn}images/pix01@2x.jpg`" alt />
            <p>
              三亚国际免税城旅游区总面积约194亩，拥有“海棠花”主题以及“贝壳”主题两大世界级建筑景观，仿生学的屋面设计，形成舒适的半室外空间，将时尚元素与三亚独有的热带气候契合，飘逸灵动，美轮美奂。连接两大建筑的步行桥是由世界顶级设计师完成的独塔万向铰斜拉上人步行景观桥，其外观神似一枚托举而起指向云天的银色钻戒而得名“云戒”，出水入云，悬浮云端，是即可以听到海也可以看到海的空中之地，是三亚国际免税城旅游区标志性景观。除此以外旅游观光景点还有云戒广场、星悦广场、水悦广场、美人鱼广场、演艺广场等。
            </p>
            <p>
              三亚国际免税城旅游区精心打造的离岛免税区、奇趣生活馆、国际创意荟萃、国际缤纷嘉年华、国际美食市集等五大服务功能区，实现了免税与有税相融、购物与休闲相融、商业与文化相融、旅游与时尚相融，丰富了三亚旅游景区新形态的同时，已成为三亚旅游新地标。
            </p>
          </div>
        </div>

        <div class="ui-content" v-else-if="type === 'msq'">
          <img
            class="close"
            @click="onClose"
            :src="`${$cdn}images/close@2x.png`"
            alt
          />
          <h1>离岛免税区</h1>
          <div class="content">
            <p>
              离岛免税区建筑面积12万平方米，是目前全球最大单体免税店。分为A、B两栋楼，引进350多个国际知名品牌，涵盖香水化妆品、服装服饰、手表首饰、奶粉、玩具、家用电器、糖果巧克力、酒类、家用电器、计算机、穿戴设备等电子消费产品、手机及电子游戏机等45类免税商品。免税店所有商品均由中免集团统一从原产地采购、受海关和检验检疫等相关单位全程监管，为消费者放心购物提供有力保障。
            </p>
            <img v-viewer  :src="`${$cdn}images/pix02@2x.jpg`" alt />
          </div>
        </div>

        <div class="ui-content" v-else-if="type === 'hxd'">
          <img
            class="close"
            @click="onClose"
            :src="`${$cdn}images/close@2x.png`"
            alt
          />
          <h1>河心岛</h1>
          <div class="content">
            <p>
              一、奇趣生活馆
            </p>
            <p>
              位于免税城二期的南端，是一家大型儿童体验馆，含有特色形象餐厅、儿童服饰等，通过云戒桥与两岸对接，为人流最多、沿海棠北路可视度最高的区域。
            </p>
            <img v-viewer :src="`${$cdn}images/pix03@2x.jpg`" alt />
            <p>
              二、国际创意荟萃
            </p>
            <p>
              位于免税城二期中部位置，是国际创意荟萃的聚集地，融合世界各地的DIY创意手工艺，给消费者带来多元的国际化体验，同时搭配轻餐饮，营造独一无二的互动体验。区域拥有中型体验式书店及体验式数码主力店，给来三亚的旅游者们提供一个可以释放和沉淀内心的空间。
            </p>
            <p>
              三、国际缤纷嘉年华
            </p>
            <p>
              以敞开式表演舞台为核心，搭配周边休闲餐饮，作为文化及娱乐空间。舞台有多个时节性相关的综艺表演，是相关娱乐节目举办并供游客放松休闲的场地。
            </p>
            <p>
              四、国际美食市集
            </p>
            <p>
              拥有集合水产、特色餐饮、生鲜超市、家居生活美学融为一体的以海洋为主题的海南首家跨界生活美学体验店Fish School，全球首家餐饮、游乐、零售三合一的海洋主题概念店B.Duck，星巴克全国首个海洋主题概念店，以及五家米其林及黑珍珠餐厅。此外，免税二期还云集三十余家特色美食，目前不论是游客还是常驻海南的居民都纷纷因为这些无法拒绝的美食饕餮，到此打卡品鉴。
            </p>
          </div>
        </div>

        <div class="ui-content ui-map" v-else>
          <img
            class="close"
            @click="onClose"
            :src="`${$cdn}images/close@2x.png`"
            alt
          /> 
          <div id="map"></div>
        </div>
      </div>
    </popup>
  </transition>
</template>
<script>
import Popup from "./popup";
import browser from "@/utils/browser";

let AMap = window.AMap

export default {
  name: "ui-tips",
  components: {
    Popup,
  },
  data() {
    return {
      show: false,
      duration: 1000,
      isMobile: browser.mobile,
      content: "",
      type: "intro",
      map:'',
      marker:''
    };
  },
  watch:{
    show(val){
      if (!val) {
        return false
      }
      setTimeout(() => {
        this.map = new AMap.Map("map", {
            resizeEnable: true,
            zoom:12,
            center: [109.750833,18.372003]
        });
        this.marker = new AMap.Marker({
            position:[109.750833,18.372003],
            icon: new AMap.Icon({            
                      image: this.$cdn + 'images/maps_nav@2x.png',
                      size: new AMap.Size(34, 42),
                      imageSize: new AMap.Size(34,42)
                  })
        });
        this.map.add(this.marker);
      }, 300);
    }
  },
  methods: {
    onClose() {
      setTimeout(() => {
        this.show = false;
        document.body.removeChild(this.$el);
        this.$destroy();
      }, 0);
    },
  },
  mounted() {
    
  },
};
</script>
<style lang="less" scoped>
.ui-message-tips {
  position: absolute;
  left: 50%;
  top: 45%;
  background-color: #fff;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  max-width: 960px;
  z-index: 999;
  .ui-content {
    position: relative;
    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 28px;
      cursor: pointer;
      z-index: 999;
    }
    > h1 {
      color: #2e2e2e;
      font-size: 24px;
      text-align: center;
      padding: 30px 0;
    }
    .content {
      padding: 0 50px 30px;
      text-align: justify;
      line-height: 1.5;
      overflow: auto;
      max-height: 70vh;
      > img {
        width: 100%;
        margin: 10px 0;
      }
      #map{
        width: 100%;
        height: 80vh;
        border-radius: 8px;
        overflow: hidden;
      }
      > p {
        text-indent: 32px;
      }
    }
  }
  .ui-map {
    padding: 0;
    min-width: 960px;
    font-size: 0;
    border-radius: 8px;
    overflow: hidden;
    .map {
      width: 100%;
    }
    #map{
      width: 100%;
      height: 514px;
      border-radius: 8px;
      overflow: hidden;
    }
  }
}
@media screen and (max-width: 500px) {
  .ui-message-tips {
    width: 80%;
    .ui-content {
      position: relative;
      padding: 0;
      .close {
        position: absolute;
        top: 5px;
        right: 5px;
        width: 24px;
        cursor: pointer;
      }
      > h1 {
        color: #2e2e2e;
        font-size: 16px;
        padding: 16px 0;
        text-align: center;
      }
      .content {
        text-align: justify;
        line-height: 1.5;
        margin-top: 0;
        margin-bottom: 10px;
        padding: 0 16px;
        overflow: auto;
        height: 60vh;
        > img {
          width: 100%;
          margin: 10px 0;
        }
      }
    }
    .ui-map {
      min-width: unset;
      #map{
        width: 100%;
        height: 80vh;
        border-radius: 8px;
        overflow: hidden;
      }
    }
  }
}
</style>